export default __webpack_public_path__ + "assets/images/e4e755aea3aacb3dc6180abb310fda8e.png";